<template><div><h1 id="auftragsstatistik-nach-kunden-und-medium" tabindex="-1"><a class="header-anchor" href="#auftragsstatistik-nach-kunden-und-medium"><span>Auftragsstatistik nach Kunden und Medium</span></a></h1>
<p>Auftragsstatistik nach Kunden und Medium — Zählt Aufträge</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Auswertung erstellt eine Statistik aus allen Aufträgen, die im gewählten Zeitraum angelegt wurden und das eingegebene Medium haben (d.h. mindestens eine Autragsposition existiert mit einem Artikel des Mediums). Das Ergebnis kann nach diversen Kriterien gruppiert werden, nach bestimmten Ereignissen, Personenmerkmalen, Personenquellen, Wiederverkäufern und Rest. Die Statistik zeigt die Summe (Anzahl) Adressen und Umsatzwerte (mit MWST) aus den Aufträgen für die eingegebenen Gruppen. Sie ist fix programmiert, wird in der Datenbank gespeichert und kann jederzeit wieder angezeigt oder ausgedruckt werden.</p>
<p>Pfad: <code v-pre>Verkauf → Auswertungen → Auftragsstatistik nach Kunden und Medium</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Medium:</dt>
<dd>Mediennummer, Muss-Eingabe</dd>
<dt>Auftr. mit ErfDatum:</dt>
<dd>Aufträge mit Erfassungsdatum ab, inklusive, leer = unbegrenzt</dd>
<dt>bis:</dt>
<dd>Aufträge mit Erfassungsdatum bis, inklusive, leer = unbegrenzt</dd>
<dt>1. Spalte:</dt>
<dd>E = Ereignis, M = Merkmal, Q = Quelle, R = Rest, W = Wiederverkäufer</dd>
<dt>2. Spalte:</dt>
<dd>Wert (Achtung: nur Ganzzahlen möglich)<div class="itemizedlist"><ul class="itemizedlist" style="list-style-type: disc; "><li class="listitem">des Ereignisses: mit Positionsnummer ohne Punkt eingeben! Auch möglich ist die 4-stellige Eingabe einer Ereignisnummer ohne Position</li><li class="listitem">des Merkmals</li><li class="listitem">der Personenquelle: Anzahl bei Quelle</li><li class="listitem">bei Rest: leer lassen</li><li class="listitem">bei Wiederverkäufer: leer lassen</li></ul></div></dd>
<dt>Ausgabe</dt>
<dd>Die Statistik erzeugt keine Ausgabe, sondern speichert ihre Ergebnisse direkt im System, abgelegt nach Erhebungsdatum und Medium.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Für jede der 26 möglichen Selektionen werden die folgenden Werte ermittelt:</p>
<ul>
<li>
<p>Die Anzahl Adressen der Selektion unabhängig von den Aufträgen. Wird z.B. nach einem Ereignis selektiert (E), dann wird die Anzahl der Initialereignisse angegeben.</p>
</li>
<li>
<p>Die Anzahl Aufträge mit einem Auftraggeber in der gewählten Adressselektion. Nur Aufträge mit mindestens einem Artikel aus dem gewählten Medium werden berücksichtigt. Die Aufträge werden unabhängig von ihrem Status selektiert.</p>
</li>
<li>
<p>Der Auftragswert (RG-Total auf der Auftragsmaske), d.h. Wert des Auftrags ohne Porto, mit MWST und reduziert um allfällige Retouren.</p>
</li>
<li>
<p>Wert pro Auftrag gibt den durchschnittlichen Auftragswert der betrachteten Gruppe aus (Auftragswert / Anzahl Aufträge).</p>
</li>
<li>
<p>In der %-Spalte wird die Responsequote der betrachteten Gruppe ausgewiesen: Anzahl Aufträge / Anzahl Adressen in Prozent.</p>
</li>
</ul>
<p>+------------------ Auftragsstatistik nach Kunden und Medium ------------------+
|Medium: 16  Auftr. mit ErfDatum: 07.11.1996 - 07.11.1996  ErhDatum: 21.11.1996|
|EMQRW    Anzahl Anzahl Auftr.  Wert/   EMQRW    Anzahl Anzahl Auftr.  Wert/   |
|         Adr.   Auftr. Wert    Auftr %          Adr.   Auftr. Wert    Auftr % |
|E 780792 0      0      0                               0      0               |
|R               635    121577  191                     0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|                0      0                               0      0               |
|E=Ereignis, M=Merkmal, Q=Quelle, R=Restliche, W=Wiederverkäufer, %=Rücklauf   |
+------------------------------------------------------------------------------+</p>
<p>635 Aufträge mit Medium 16 wurden am 7.11.1996 erfasst. Unter diesen Aufträgen war keiner mit einem Auftraggeber, welcher das Ereignis 7807.92 hatte. Deshalb werden alle Aufträge in der Zeile R ausgewiesen. (Es gibt überhaupt keine Adresse mit dem Ereignis 7807.92).</p>
<div class="hint-container tip">
<p class="hint-container-title">Anmerkung</p>
<p>Spendeartikel werden in dieser Statistik nicht mitgezählt.</p>
</div>
</div></template>


